import { render, staticRenderFns } from "./AdminBooksBank.vue?vue&type=template&id=e9084a9e&scoped=true"
import script from "./AdminBooksBank.vue?vue&type=script&lang=js"
export * from "./AdminBooksBank.vue?vue&type=script&lang=js"
import style0 from "./AdminBooksBank.vue?vue&type=style&index=0&id=e9084a9e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9084a9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9084a9e')) {
      api.createRecord('e9084a9e', component.options)
    } else {
      api.reload('e9084a9e', component.options)
    }
    module.hot.accept("./AdminBooksBank.vue?vue&type=template&id=e9084a9e&scoped=true", function () {
      api.rerender('e9084a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminBooksBank.vue"
export default component.exports